module.exports = __webpack_public_path__ + "static/media/banner_news_assistente_juridico.34282dba.png";